import { render, staticRenderFns } from "./Slideshows.vue?vue&type=template&id=1a510614&scoped=true&"
import script from "./Slideshows.vue?vue&type=script&lang=js&"
export * from "./Slideshows.vue?vue&type=script&lang=js&"
import style0 from "./Slideshows.vue?vue&type=style&index=0&id=1a510614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a510614",
  null
  
)

export default component.exports